const formatter = new Intl.NumberFormat('en-CA', { style: 'currency', currency: 'CAD' });
export const parsePrice = (value: number | string) => {
  if (value) {
    return formatter.format(parseInt(value.toString()));
  }

  return 0;
};
